/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import * as _l from 'lodash';

import { AlertEventInfo } from 'services/lib/dto/AlertEventInfo';
import './alertEvent.scss';
import './alertEvent.tpl.html';

angular.module('chatter.alertEvent', ['sbsf.constants']).controller('ChatterAlertEventCtrl', controller);

/**
 * The controller for the chatter alert event view. Since the Salesforce Visualforce page can only pass the batch id
 * and not the event id, we can only display the complete list of alerts here rather than the single alert from the post.
 */
function controller($scope, eventList, TYPES) {
  $scope.getEventDescription = getEventDescription;
  $scope.getObjectTypeIconClass = getObjectTypeIconClass;
  $scope.showBatchInApp = showBatchInApp;

  $scope.eventList = eventList;

  /**
   * Returns the text description of an alert event.
   *
   * @param {IAlertEventDtoCreateProps} event - the event whose description is desired
   * @returns {string} the description.
   */
  function getEventDescription(event) {
    return AlertEventInfo.getDescription(event);
  }

  /**
   * Returns the class representing the icon image for the object type in an event.
   *
   * @param {object} event - the event whose object type icon class is desired
   * @returns {string} The class
   */
  function getObjectTypeIconClass(event) {
    return TYPES.typeToCls[event.objectType];
  }

  /**
   * Displays the backup results for the batch in which these alerts were triggered.
   */
  function showBatchInApp() {
    // Obtain the batch id from the first event
    const event = _l.first(eventList);
    $scope.gotoApp(`?batchId=${event && event.batchId}&page=batch`);
  }
}
